export default __webpack_public_path__ + "static/media/oldtbilisi-restaurant.03e659e5.jpg";